// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2wB5M","header":"styles_header__3g5_6"};